import { InheritanceStatus, Slug } from '../Quests/Quest.Interfaces'

export enum PromptType {
  AUTO_COMPLETE = 'auto_complete',
  SUMMARY = 'summary',
  REVIEW_REPLY = 'review_reply',
  NORMAL = 'normal'
}

export interface PromptInterface {
  slug: string
  botId: string
  inheritance?: InheritanceStatus
  type: PromptType
  name: string
  text: string
}

export enum PromptStackItemType {
  PROMPT = 'prompt',
  TEXT = 'text',
  PREVIOUS_MESSAGES = 'previous_messages'
}

export type PromptStackItem =
  | PromptStackItem_PROMPT
  | PromptStackItem_TEXT
  | PromptStackItem_PREVIOUS_MESSAGES

export interface PromptStackItem_PROMPT {
  id: string
  type: PromptStackItemType.PROMPT
  promptSlug: Slug
}

export interface PromptStackItem_TEXT {
  id: string
  type: PromptStackItemType.TEXT
  text: string
}

export interface PromptStackItem_PREVIOUS_MESSAGES {
  id: string
  type: PromptStackItemType.PREVIOUS_MESSAGES
  numberOfMessagesToLoad: number
}
